/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { CotizadorContext } from '../context';
import { getTotalFromSimulation, runSimulation } from '../components/utils/creditSimulation';

const useDistanceData= () => {
    const [state, setState] = useContext(CotizadorContext)

    const setSelectedDistance = async selected_distance => {

        let simulation = null;

        if (state.selected_car) {
            document.getElementById('cotizador_overlay').style.display = 'block';
            const simulationResult = await runSimulation(state.selected_car, state.selected_time, selected_distance, state.downpayment_percentage);
            simulation = simulationResult.data;

            if (!simulationResult.success) {
                console.error('[useDistanceData] Error en simulación:', simulationResult.error);
            }

            setState(prevState => ({
                ...prevState,
                selected_distance,
                simulation_results: simulation,
                simulation_total: getTotalFromSimulation(simulation),
                ...(simulationResult.success ? {} : { error_notification: simulationResult.error }),
            }))
        } else {
            setState(prevState => ({
                ...prevState,
                selected_distance,
                simulation_results: simulation
            }))
        }

        
        document.getElementById('cotizador_overlay').style.display = 'none';
    }

    const enableAllOptions = () => {
        setState(prevState => {
            const distance_options = [...prevState.distance_options];
            distance_options.forEach(option => {
                option.enabled = true
            });

            return {
                ...prevState,
                distance_options
            }
        })
    }

    const getSelectedDistance = () => state.selected_distance

    return {
        distance_options: state.distance_options,
        setSelectedDistance,
        getSelectedDistance,
        enableAllOptions,
    };
}

export default useDistanceData;